import React from 'react';
import { Client, TripInfo, ItineraryItem, TravellerInfo } from '../../types/Quotation';
import PDFHeader from './PDFHeader';
import TripSummary from './TripSummary';
import CostSummary from './CostSummary';
import CuratorDetails from './CuratorDetails';

interface PDFPage1Props {
  client: Client;
  tripInfo: TripInfo;
  itinerary: ItineraryItem[];
  highlights: string;
}

const PDFPage1: React.FC<PDFPage1Props> = ({ client, tripInfo, itinerary, highlights }) => {
  const formatTravellers = (travellers: TravellerInfo) => {
    const { adults, children, infants } = travellers;
    const parts: string[] = [];
    if (adults) parts.push(`${adults} Adult${adults > 1 ? 's' : ''}`);
    if (children) parts.push(`${children} Child${children > 1 ? 'ren' : ''}`);
    if (infants) parts.push(`${infants} Infant${infants > 1 ? 's' : ''}`);
    return parts.join(', ') || 'N/A';
  };

  return (
  <div className="pdf-page">
    <PDFHeader />
    <TripSummary
      client={client}
      tripInfo={tripInfo}
      itinerary={itinerary}
      highlights={highlights}
    />
    <CostSummary
      totalPrice={tripInfo.totalPrice || 0}
      paxLabel={formatTravellers(tripInfo.travellers)}
      paymentLink={tripInfo.paymentLink || ""}
    />
    <CuratorDetails />
  </div>
  );
};

export default PDFPage1;